import React from "react";
import { useSearchParams } from "react-router-dom";
import { MetaOSAppContext } from "../../pages/metaos/MetaOSAppContext";
import { isMetaOsHelper } from "../../utils/url";

export type ManageAccessHookResultType = {
  openDialog: () => void;
};

export const useManageAccess = (): ManageAccessHookResultType => {
  const [searchParams, setSearchParams] = useSearchParams();
  const context = React.useContext(MetaOSAppContext);

  const openDialog = React.useCallback(() => {
    if (isMetaOsHelper()) {
      context.manageAccessDialog = true;
      context.updateContext(context);
    } else {
      searchParams.set("manageAccess", "open");
      setSearchParams(searchParams);
    }
  }, [context, searchParams, setSearchParams]);

  return {
    openDialog,
  };
};
